module.exports = __webpack_public_path__ + "img/08_Lichttechnik-Tabelle.710bf486.svg";